export const locale = {
    'FullscreenControl.Enter': '进入全屏',
    'FullscreenControl.Exit': '退出全屏',
    'NavigationControl.ZoomIn': '放大',
    'NavigationControl.ZoomOut': '缩小',
    'NavigationControl.ResetBearing': '方位角复位',
    'ScaleControl.Meters': '', // 如果制图单位不是米，请修改。如制图单位是毫米，可改成毫米，如果没有制图单位，可为空
    'ScaleControl.Kilometers': 'K',// 如果制图单位不是米，请修改。如制图单位是毫米，可改成米，如果没有制图单位，可写为k
}